import React from 'react'
import { withFirebase } from '../../components/Fb'

// reactstrap components
import {
  Row,
  Col
} from 'reactstrap'

// core components
import MediaLibrary from '../../components/Lists/MediaLibrary'

class MediaLibraryContainer extends React.Component {
  render () {
    return (
      <>
        <div className='content'>
          <Row>
            <Col md='12'>
              <MediaLibrary {...this.props} />
            </Col>
          </Row>
        </div>
      </>
    )
  }
}

export default withFirebase(MediaLibraryContainer)
